import React, { useEffect, useRef, useState } from 'react';
import { experienceData } from '../data/mock';

const Experience = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="experience"
      ref={sectionRef}
      className="relative py-24 lg:py-32 overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="/images/image11.jpg"
          alt="CRISPYzza experience"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[#1e1919]/85" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left - Content */}
          <div
            className={`transition-all duration-1000 ${
              isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'
            }`}
          >
            <span className="text-[#c9a962] text-sm font-semibold tracking-[0.2em] uppercase">
              {experienceData.tagline}
            </span>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white mt-4 mb-12">
              {experienceData.headline}
            </h2>

            {/* Experience Steps */}
            <div className="space-y-8">
              {experienceData.items.map((item, index) => (
                <div
                  key={index}
                  className={`flex items-start gap-6 transition-all duration-700 ${
                    isVisible
                      ? 'opacity-100 translate-x-0'
                      : 'opacity-0 -translate-x-10'
                  }`}
                  style={{ transitionDelay: `${index * 200 + 300}ms` }}
                >
                  <div className="flex-shrink-0 w-16 h-16 bg-[#c9a962] rounded-full flex items-center justify-center">
                    <span className="font-display text-2xl font-bold text-[#1e1919]">
                      {item.number}
                    </span>
                  </div>
                  <div>
                    <h3 className="font-display text-2xl font-bold text-white mb-2">
                      {item.title}
                    </h3>
                    <p className="text-[#bbb5ae] text-lg">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right - The Crunch Quote */}
          <div
            className={`transition-all duration-1000 delay-500 ${
              isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'
            }`}
          >
            <div className="relative">
              {/* Background decoration */}
              <div className="absolute -inset-4 bg-gradient-to-br from-[#c9a962]/20 to-transparent rounded-3xl blur-xl" />
              
              <div className="relative bg-white/5 backdrop-blur-lg border border-white/10 rounded-3xl p-10 lg:p-12">
                <div className="text-center">
                  <h3 className="font-display text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6">
                    The
                    <span className="block gradient-text">Crunch</span>
                  </h3>
                  <p className="text-xl md:text-2xl text-[#bbb5ae] italic">
                    "You hear it before you taste it"
                  </p>
                </div>

                {/* Sound wave decoration */}
                <div className="flex items-center justify-center gap-1 mt-10">
                  {[...Array(20)].map((_, i) => (
                    <div
                      key={i}
                      className="w-1 bg-[#c9a962] rounded-full"
                      style={{
                        height: `${Math.sin((i / 3) * Math.PI) * 30 + 10}px`,
                        opacity: 0.3 + Math.sin((i / 3) * Math.PI) * 0.7,
                        animationDelay: `${i * 0.05}s`,
                      }}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
